module.exports = __webpack_public_path__ + "img/product.ea0c8c83.png";